/**
 * Enum of all database Views available to the client.
 *
 */
export enum DatabaseView {
  AdminWithAppointments = 'adminWithAppointmentsRecord',
  DeviceWithDetail = 'deviceWithDetailRecord',
  DueDate = 'dueDateRecord',
  EventWithDetail = 'eventWithDetailRecord',
  PeopleWithStatus = 'peopleWithStatusRecord'
}
